import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Toasts } from '../../Components/Toasts/Toasts';
import { requestAdminLogin, verifyAdminLogin } from './saga/saga';

const theme = createTheme();

export const Login = () => {
  const [stage, setStage] = React.useState('email'); // 'email' | 'code'
  const [email, setEmail] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  const handleRequest = async (event) => {
    event.preventDefault();
    if (!email) {
      Toasts.error('Email is required');
      return;
    }
    setBusy(true);
    const ok = await requestAdminLogin({ email });
    setBusy(false);
    if (ok) setStage('code');
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const code = data.get('code');
    if (!code) {
      Toasts.error('Code is required');
      return;
    }
    setBusy(true);
    try {
      await verifyAdminLogin({ email, code });
    } finally {
      setBusy(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h5">
            Admin sign in
          </Typography>

          {stage === 'email' ? (
            <Box component="form" onSubmit={handleRequest} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button
                style={{ backgroundColor: 'rgb(46, 125, 50)' }}
                type="submit"
                fullWidth
                variant="contained"
                disabled={busy}
                sx={{ mt: 3, mb: 2 }}
              >
                Send sign-in code
              </Button>
            </Box>
          ) : (
            <Box component="form" onSubmit={handleVerify} noValidate sx={{ mt: 1 }}>
              <Typography variant="body2" sx={{ mt: 2 }}>
                We sent a 6-digit code to <strong>{email}</strong>. Enter it below to sign in.
              </Typography>
              <TextField
                margin="normal"
                required
                fullWidth
                id="code"
                label="6-digit code"
                name="code"
                autoComplete="one-time-code"
                autoFocus
              />
              <Button
                style={{ backgroundColor: 'rgb(46, 125, 50)' }}
                type="submit"
                fullWidth
                variant="contained"
                disabled={busy}
                sx={{ mt: 3, mb: 1 }}
              >
                Verify and sign in
              </Button>
              <Button
                fullWidth
                variant="text"
                onClick={() => setStage('email')}
                sx={{ mb: 2 }}
              >
                Use a different email
              </Button>
            </Box>
          )}
        </Box>
      </Container>
    </ThemeProvider>
  );
};
